export const alertConstants = {
    SUCCESS:'ALERT_SUCCESS',
    ERROR:'ALERT_ERROR',
    CLEAR:'ALERT_CLEAR'
}